import { createRouter, createWebHistory } from "vue-router"
import Dashboard from "./views/Dashboard.vue"
import NotFound from "./views/NotFound.vue"
import Login from "./views/Login.vue"

const routes = [
    {
        path: "/",
        component: Dashboard,
        alias: "/dashboard"
    },
    {
        path: "/global-settings",
        name: "Global Settings",
        // route level code-splitting
        // this generates a separate chunk (global-settings.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "global-settings" */ "./views/GlobalSettings.vue")
    },
    {
        path: "/login",
        name: "Login",
        component: Login
        // component: () =>
        //   import(/* webpackChunkName: "platforms" */ "./views/Login.vue"),
    },
    {
        // Used if a new user is required to change their password upon login
        path: "/login-set-password",
        name: "LoginSetPassword",
        component: () => import(/* webpackChunkName: "platforms" */ "./views/LoginSetNewPassword.vue")
    },
    {
        // Used if a password reset request has been performed and the user needs to set their new password using the emailed reset code
        path: "/login-reset-password",
        name: "LoginResetPassword",
        component: () => import(/* webpackChunkName: "platforms" */ "./views/LoginResetPassword.vue")
    },
    {
        // Used by a user to perform a password reset
        path: "/login-forgot-password",
        name: "Password Reset",
        component: () => import(/* webpackChunkName: "platforms" */ "./views/LoginForgotPassword.vue")
    },
    {
        path: "/news",
        name: "News",
        component: () => import(/* webpackChunkName: "news" */ "./views/News.vue"),
        children: [
            {
                path: "",
                name: "News Management",
                component: () => import(/* webpackChunkName: "news" */ "./components/News/NewsManagement.vue")
            },
            {
                path: "/news/:id",
                name: "News Content",
                component: () => import(/* webpackChunkName: "news" */ "./components/News/NewsContent.vue")
            }
        ]
    },
    {
        path: "/media",
        name: "Media",
        component: () => import(/* webpackChunkName: "media" */ "./views/Media.vue"),

        children: [
            {
                path: "",
                name: "Media Management",
                component: () => import(/* webpackChunkName: "media" */ "./components/Media/V2/MediaManagementV2.vue")
            },
            {
                path: "/media/:id",
                name: "Media Editor",
                component: () => import(/* webpackChunkName: "media" */ "./components/Media/MediaItem.vue")
            }
        ]
    },
    {
        path: "/advertising",
        name: "Advertising",
        component: () => import(/* webpackChunkName: "Advertising" */ "./views/Advertising.vue"),
        children: [
            {
                path: "",
                name: "Manager",
                component: () => import(/* webpackChunkName: "AdvertisingManager" */ "./components/Advertising/Advertising2/AdvertisingManager2.vue")
            }
        ]
    },
    {
        path: "/forms",
        name: "Forms",
        component: () => import(/* webpackChunkName: "Forms" */ "./views/Forms.vue"),
        children: [
            {
                path: "",
                name: "Form Management",
                component: () => import(/* webpackChunkName: "FormsManagement" */ "./components/Forms/FormsManagement.vue")
            },

            {
                path: "/forms/:id",
                name: "Form Edit",
                props: true,
                component: () => import(/* webpackChunkName: "FormEdit" */ "./components/Forms/FormEdit.vue")
            }
        ]
    },
    {
        path: "/settings-management",
        name: "Settings Management",
        component: () => import(/* webpackChunkName: "SettingsManager" */ "./views/SettingsManager.vue"),
        children: [
            {
                path: "",
                name: "Settings Manager",
                component: () => import(/* webpackChunkName: "SettingsManager" */ "./components/SettingsManager/SettingsManager.vue")
            },
            {
                path: "/settings-management/core",
                name: "Core Settings",
                component: () => import(/* webpackChunkName: "SettingsManager" */ "./components/SettingsManager/CoreSettingsManager.vue")
            },
            {
                path: "/settings-management/football",
                name: "Football Settings",
                component: () => import(/* webpackChunkName: "SettingsManager" */ "./components/SettingsManager/FootballSettingsManager.vue")
            },
            {
                path: "/settings-management/ecommerce",
                name: "Ecommerce Settings",
                component: () => import(/* webpackChunkName: "SettingsManager" */ "./components/SettingsManager/EcommerceSettingsManager.vue")
            },
            {
                path: "/settings-management/ticketing",
                name: "Ticketing Settings",
                component: () => import(/* webpackChunkName: "SettingsManager" */ "./components/SettingsManager/TicketingSettingsManager.vue")
            },
            {
                path: "/settings-management/social",
                name: "Social Settings",
                component: () => import(/* webpackChunkName: "SettingsManager" */ "./components/SettingsManager/SocialSettingsManager.vue")
            },
            {
                path: "/settings-management/app-configuration",
                name: "App Settings",
                component: () => import(/* webpackChunkName: "SettingsManager" */ "./components/SettingsManager/AppSettingsManager.vue")
            },
            {
                path: "/settings-management/dev",
                name: "Dev Settings",
                component: () => import(/* webpackChunkName: "SettingsManager" */ "./components/SettingsManager/DevSettingsManager.vue")
            },
            {
                path: "/settings-management/legacy-web-settings",
                name: "Legacy Web Settings",
                component: () => import(/* webpackChunkName: "SettingsManager" */ "./components/SettingsManager/LegacyWebSettingsManager.vue")
            }
        ]
    },
    {
        path: "/website-management",
        name: "Website Management",
        component: () => import(/* webpackChunkName: "WebsiteManager" */ "./views/WebsiteManager.vue"),
        children: [
            {
                path: "",
                name: "Website Manager",
                component: () => import(/* webpackChunkName: "WebsiteManager" */ "./components/WebsiteManager/WebsiteManager.vue")
            }
        ]
    },
    {
        path: "/app-management",
        name: "App Management",
        component: () => import(/* webpackChunkName: "AppConfig" */ "./views/AppConfig.vue"),
        children: [
            {
                path: "",
                name: "Dashboard",
                component: () => import(/* webpackChunkName: "AppDashboard" */ "./components/AppConfig/AppDashboard.vue")
            },
            {
                path: "/app-management/ticketing-links",
                name: "Ticketing Links Manager",
                component: () => import(/* webpackChunkName: "TicketingLinksManager" */ "./components/AppConfig/TicketingLinksManager.vue")
            },
            {
                path: "/app-management/ecommerce-links",
                name: "Ecommerce Links Manager",
                component: () => import(/* webpackChunkName: "EcommerceLinksManager" */ "./components/AppConfig/EcommerceLinksManager.vue")
            },
            {
                path: "/app-management/social-links",
                name: "Social Links Manager",
                component: () => import(/* webpackChunkName: "SocialLinksManager" */ "./components/AppConfig/SocialLinksManager.vue")
            },
            {
                path: "/app-management/app-configuration",
                name: "Config Manager",
                component: () => import(/* webpackChunkName: "AppSettings" */ "./components/PlatformSettings/AppSettings.vue")
            },
            {
                path: "/app-management/rewards-manager",
                name: "Rewards Manager",
                component: () => import(/* webpackChunkName: "RewardsManager" */ "./components/Rewards/RewardsManager.vue")
            }
        ]
    },
    {
        path: "/sponsors",
        name: "Sponsors",
        component: () => import(/* webpackChunkName: "Advertising" */ "./views/Sponsors.vue"),
        children: [
            {
                path: "",
                name: "Sponsors Selector",
                component: () => import(/* webpackChunkName: "ConfigSelector" */ "./components/Sponsors/SponsorsSelector.vue")
            },
            {
                path: "/sponsors/footer",
                name: "Footer Sponsors",
                component: () => import(/* webpackChunkName: "HomepageEditor" */ "./components/Sponsors/Subpages/FooterSponsors/FooterSponsors.vue")
            },
            {
                path: "/sponsors/menu",
                name: "Menu",
                props: {
                    appID: "menu_App",
                    webID: "menu_Web"
                },
                component: () => import(/* webpackChunkName: "HomepageEditor" */ "./components/Sponsors/Subpages/SectionSponsors/SectionSponsors.vue")
            },
            {
                path: "/sponsors/loading-screen",
                name: "App Loading Screen",
                props: {
                    appID: "loadingScreen_App"
                },
                component: () => import(/* webpackChunkName: "HomepageEditor" */ "./components/Sponsors/Subpages/SectionSponsors/SectionSponsors.vue")
            },
            {
                path: "/sponsors/homepage-news",
                name: "Homepage News",
                props: {
                    appID: "homepageNews_App",
                    webID: "homepageNews_Web"
                },
                component: () => import(/* webpackChunkName: "HomepageEditor" */ "./components/Sponsors/Subpages/SectionSponsors/SectionSponsors.vue")
            },
            {
                path: "/sponsors/news-listing",
                name: "News Listing Page",
                props: {
                    appID: "newsListing_App",
                    webID: "newsListing_Web"
                },
                component: () => import(/* webpackChunkName: "HomepageEditor" */ "./components/Sponsors/Subpages/SectionSponsors/SectionSponsors.vue")
            },
            {
                path: "/sponsors/match-centre-first-team",
                name: "Match Centre - First Team",
                props: {
                    appID: "matchCentre_FirstTeam_App",
                    webID: "matchCentre_FirstTeam_Web"
                },
                component: () => import(/* webpackChunkName: "HomepageEditor" */ "./components/Sponsors/Subpages/SectionSponsors/SectionSponsors.vue")
            },
            {
                path: "/sponsors/fixtures-page-first-team",
                name: "Fixtures Page - First Team",
                props: {
                    appID: "fixturesPage_FirstTeam_App",
                    webID: "fixturesPage_FirstTeam_Web"
                },
                component: () => import(/* webpackChunkName: "HomepageEditor" */ "./components/Sponsors/Subpages/SectionSponsors/SectionSponsors.vue")
            },
            {
                path: "/sponsors/player-of-the-match",
                name: "Player of the Match",
                props: {
                    appID: "playerOfTheMatch_App",
                    webID: "playerOfTheMatch_Web"
                },
                component: () => import(/* webpackChunkName: "HomepageEditor" */ "./components/Sponsors/Subpages/SectionSponsors/SectionSponsors.vue")
            },
            {
                path: "/sponsors/ranking-sponsor-link",
                name: "Ranking sponsors",
                props: {
                    webID: "rankingSponsor_Web"
                },
                component: () => import(/* webpackChunkName: "HomepageEditor" */ "./views/Sponsors.vue"),
                children: [
                    {
                        path: "",
                        name: "Ranking sponsors selector",
                        component: () =>
                            import(/* webpackChunkName: "HomepageEditor" */ "./components/Sponsors/Subpages/RankingSponsors/RankingSponsorsList.vue")
                    },

                    {
                        path: "/sponsors/ranking-sponsor-link/:rankingID",
                        name: "Single Ranking Sponsor",
                        props: route => ({
                            rankingID: route.params.rankingID
                        }),
                        component: () =>
                            import(/* webpackChunkName: "FixtureEditor" */ "./components/Sponsors/Subpages/RankingSponsors/AddEditRankingSponsor.vue")
                    },
                    {
                        path: "/sponsors/ranking-sponsor-link/add-new-ranking-sponsor-link",
                        name: "Add new Ranking sponsors",
                        component: () =>
                            import(
                                /* webpackChunkName: "HomepageEditor" */ "./components/Sponsors/Subpages/RankingSponsors/AddEditRankingSponsor.vue"
                            )
                    }
                ]
            },

            {
                path: "/sponsors/score-predictor",
                name: "Score Predictor",
                props: {
                    appID: "scorePredictor_App",
                    webID: "scorePredictor_Web"
                },
                component: () => import(/* webpackChunkName: "HomepageEditor" */ "./components/Sponsors/Subpages/SectionSponsors/SectionSponsors.vue")
            }
        ]
    },
    {
        path: "/rankings",
        name: "Rankings",
        component: () => import(/* webpackChunkName: "Advertising" */ "./views/Rankings.vue"),
        children: [
            {
                path: "",
                name: "Ranking List",
                component: () => import(/* webpackChunkName: "ConfigSelector" */ "./components/Rankings/RankingsList.vue")
            },
            {
                path: "/rankings/:rankingID",
                name: "Single Ranking",
                props: route => ({
                    rankingID: route.params.id
                }),
                component: () => import(/* webpackChunkName: "FixtureEditor" */ "./components/Rankings/Subpages/AddOrEditRankings.vue")
            }
        ]
    },
    {
        path: "/team-management",
        name: "Team Management",
        component: () => import(/* webpackChunkName: "TeamManagement" */ "./views/TeamManagement.vue"),
        children: [
            {
                path: "",
                name: "Team Management",
                component: () => import(/* webpackChunkName: "TeamManagement" */ "./components/TeamManagement/TeamManagement.vue")
            },
            {
                name: "Team Crests",
                path: "/team-management/team-crests",
                component: () => import(/* webpackChunkName: "TeamManagement" */ "./components/TeamCrests/TeamCrestManager.vue")
            },
            {
                path: "/team-management/fixtures",
                name: "Fixtures",
                component: () => import(/* webpackChunkName: "fixtures" */ "./views/Fixtures.vue"),
                children: [
                    {
                        path: "",
                        name: "Fixture Management",
                        component: () => import(/* webpackChunkName: "FixturesManager" */ "./components/Fixtures/FixturesManager.vue")
                    },
                    {
                        path: "/team-management/fixtures/:seasonID/:teamID/:matchID",
                        name: "Fixture Editor",
                        props: route => ({
                            seasonID: route.params.seasonID,
                            teamID: route.params.teamID,
                            matchID: route.params.matchID,
                            dataType: route.query.dataType
                        }),
                        component: () => import(/* webpackChunkName: "FixtureEditor" */ "./components/Fixtures/FixtureEditor.vue")
                    }
                ]
            },
            {
                path: "/team-management/fixture-management",
                name: "Rugby Fixtures",
                component: () => import(/* webpackChunkName: "fixtures" */ "./views/Fixtures.vue"),
                children: [
                    {
                        path: "",
                        name: "Rugby Fixture Management",
                        component: () => import(/* webpackChunkName: "FixturesManager" */ "./components/RugbyFixtures/FixturesManager.vue")
                    },
                    {
                        path: "/team-management/fixture-management/:seasonID/:teamID/:matchID",
                        name: "Rugby Fixture Editor",
                        props: route => ({
                            seasonID: route.params.seasonID,
                            teamID: route.params.teamID,
                            matchID: route.params.matchID,
                            dataType: route.query.dataType
                        }),
                        component: () => import(/* webpackChunkName: "FixtureEditor" */ "./components/RugbyFixtures/FixtureEditor.vue")
                    }
                ]
            },
            {
                path: "/team-management/squads",
                name: "Squads",
                component: () => import(/* webpackChunkName: "squads" */ "./views/Squads.vue"),
                children: [
                    {
                        path: "",
                        name: "Squads Management",
                        component: () => import(/* webpackChunkName: "SquadsManagement" */ "./components/Squads/SquadsManagement.vue")
                    },
                    {
                        path: "/team-management/team/:teamID/season/:seasonID/player/:playerType/:playerID",
                        name: "Player Editor V3",
                        component: () => import(/* webpackChunkName: "PlayerManagementV3" */ "./components/Squads/PlayerManagementV3.vue")
                    },
                    {
                        path: "/team-management/team/:teamID/season/:seasonID/player/:playerType/:playerID",
                        name: "Player Editor",
                        component: () => import(/* webpackChunkName: "PlayerManagement" */ "./components/Squads/PlayerManagement.vue")
                    },
                    {
                        path: "/team-management/tables/:teamID/:seasonID/:tableID",
                        name: "Table Editor",
                        component: () => import(/* webpackChunkName: "CustomTableEdit" */ "./components/Squads/CustomTableEdit.vue")
                    }
                ]
            }
        ]
    },
    {
        path: "/tour-management",
        name: "Tour Management",
        component: () => import(/* webpackChunkName: "TeamManagement" */ "./views/TourManagement.vue"),
        children: [
            {
                path: "",
                name: "Tour management",
                component: () => import(/* webpackChunkName: "TourManagement" */ "./components/TourManagement/TourManagement.vue")
            },
            {
                path: "/tour-management/player-management/",
                name: "Player Management",
                component: () => import(/* webpackChunkName: "PlayerManagement" */ "./views/TourManagement.vue"),
                children: [
                    {
                        path: "",
                        name: "Players",
                        component: () => import(/* webpackChunkName: "SquadsManagement" */ "./components/TourManagement/PlayerListing.vue")
                    },
                    {
                        path: "/tour-management/player-management/:playerID",
                        name: "Snooker Player Editor",
                        component: () =>
                            import(/* webpackChunkName: "PlayerManagement" */ "./components/TourManagement/Playermanagement/PlayerManagement.vue")
                    }
                ]
            },
            {
                path: "/tour-management/tournament-management/",
                name: "Tournament Management",
                component: () => import(/* webpackChunkName: "PlayerManagement" */ "./views/TourManagement.vue"),
                children: [
                    {
                        path: "",
                        name: "Tournaments",
                        component: () => import(/* webpackChunkName: "SquadsManagement" */ "./components/TourManagement/TournamentListing.vue")
                    },
                    {
                        path: "/tour-management/tournament-management/:tournamentID",
                        name: "Tournament Editor",
                        component: () =>
                            import(
                                /* webpackChunkName: "PlayerManagement" */ "./components/TourManagement/TournamentManagement/TournamentManagement.vue"
                            )
                    }
                ]
            },
            {
                path: "/tour-management/matches-management/",
                name: "Matches Management",
                component: () => import(/* webpackChunkName: "PlayerManagement" */ "./views/TourManagement.vue"),
                children: [
                    {
                        path: "",
                        name: "Matches",
                        component: () => import(/* webpackChunkName: "SquadsManagement" */ "./components/TourManagement/MatchesListing.vue")
                    },
                    {
                        path: "/tour-management/match-management/:matchID",
                        name: "Fixtures Editor",
                        component: () =>
                            import(/* webpackChunkName: "PlayerManagement" */ "./components/TourManagement/MatchesManagement/MatchesManagement.vue")
                    }
                ]
            }
        ]
    },
    {
        path: "/streamline",
        name: "streamline",
        component: () => import(/* webpackChunkName: "videos" */ "./views/Streamline.vue"),
        children: [
            {
                path: "",
                name: "Streamline Management",
                component: () => import(/* webpackChunkName: "videos" */ "./components/Streamline/VideoManagement.vue")
            },
            {
                path: "/streamline/ondemand/:id",
                name: "Streamline Content",
                component: () => import(/* webpackChunkName: "videos" */ "./components/Streamline/VideoContent.vue")
            },
            {
                path: "/streamline/live/:id",
                name: "Live Stream",
                component: () => import(/* webpackChunkName: "videos" */ "./components/Streamline/LiveStreamingContent.vue")
            },
            {
                path: "/streamline/georestriction-profiles/:id",
                name: "Georestriction Profiles",
                component: () =>
                    import(/* webpackChunkName: "videos" */ "./components/Streamline/Tools/GeorestrictionProfiles/GeorestrictionProfileEdit.vue")
            },
            {
                path: "/streamline/package/create-package",
                name: "Create Package",
                component: () => import(/* webpackChunkName: "videos" */ "./components/Streamline/PackagesContent.vue")
            },
            {
                path: "/streamline/package/:id",
                name: "Edit Package",
                component: () => import(/* webpackChunkName: "videos" */ "./components/Streamline/PackagesContent.vue")
            }
        ]
    },
    {
        path: "/calendar",
        name: "Calendar",
        component: () => import(/* webpackChunkName: "videos" */ "./views/Calendar.vue"),
        children: [
            {
                path: "",
                name: "Listing",
                component: () => import(/* webpackChunkName: "VideoManagement" */ "./components/Calendar/CalendarListing.vue")
            },
            {
                path: "/calendar/:id",
                name: "Calendar Edit",
                component: () => import(/* webpackChunkName: "VideoContent" */ "./components/Calendar/Edit/CalendarEdit.vue")
            }
        ]
    },
    {
        path: "/pages",
        name: "Pages",
        component: () => import(/* webpackChunkName: "pages" */ "./views/Pages.vue"),
        children: [
            {
                path: "",
                name: "Pages Management",
                component: () => import(/* webpackChunkName: "pages" */ "./components/Pages/PageManagementNewMove.vue")
            },
            {
                path: "pages/legacy",
                name: "Legacy",
                component: () => import(/* webpackChunkName: "pages" */ "./components/Pages/PageManagement.vue")
            },
            {
                path: "/pages/:id",
                name: "Page Content",
                component: () => import(/* webpackChunkName: "pages" */ "./components/Pages/PageContent.vue")
            }
        ]
    },
    {
        path: "/content-feed",
        name: "App Content Feed",
        component: () => import(/* webpackChunkName: "ContentFeed" */ "./views/ContentFeed.vue"),
        children: [
            {
                path: "",
                name: "App Content Feed Manager",
                component: () => import(/* webpackChunkName: "ContentFeedManager" */ "./components/ContentFeed/ContentFeedManager.vue")
            }
        ]
    },
    {
        path: "/broadcasters",
        name: "Broadcasters",
        component: () => import(/* webpackChunkName: "Broadcasters" */ "./views/Broadcasters.vue"),
        children: [
            {
                path: "",
                component: () => import(/* webpackChunkName: "BroadcastersListing" */ "./components/Broadcasters/BroadcastersListing.vue")
            }
        ]
    },
    {
        path: "/organisations",
        name: "Organisations",
        component: () => import(/* webpackChunkName: "Organisations" */ "./views/Organisations.vue"),

        children: [
            {
                path: "",
                name: "organisation-manager",
                component: () => import(/* webpackChunkName: "OrganisationsManager" */ "./components/Organisations/OrganisationsManager.vue")
            },
            {
                path: "/organisations/:id",
                name: " Edit Organisation",
                props: true,
                component: () => import(/* webpackChunkName: "EditOrganisation" */ "./components/Organisations/EditOrganisation.vue")
            },
            {
                path: "/organisationTypes/:id",
                name: " Edit Organisation Type",
                props: true,
                component: () => import(/* webpackChunkName: "EditOrganisation" */ "./components/Organisations/EditOrganisationType.vue")
            }
        ]
    },
    {
        path: "/map-directory",
        name: "Map Directory",
        component: () => import(/* webpackChunkName: "MapDirectoryManager" */ "./views/MapDirectory.vue"),
        alias: "/dashboard",
        children: [
            {
                path: "",
                name: "map-directory-manager",
                component: () => import(/* webpackChunkName: "MapDirectoryManager" */ "./components/MapDirectory/MapDirectoryManager.vue")
            },
            {
                path: "/map-directory/categories/:category_id/locations-list",
                name: "Locations List",
                props: true,
                component: () => import(/* webpackChunkName: "MapLocationsList" */ "./components/MapDirectory/Locations/MapLocationsList.vue")
            },
            {
                path: "/map-directory/categories/:category_id/locations-list/:location_id",
                name: "Create Locations",
                props: true,
                component: () => import(/* webpackChunkName: "CreateMapLocation" */ "./components/MapDirectory/Locations/EditMapLocations.vue")
            },
            {
                path: "/map-directory/categories/:id",
                name: "Create Category",
                props: true,
                component: () => import(/* webpackChunkName: "CreateMapCateogory" */ "./components/MapDirectory/Categories/EditMapCategories.vue")
            },
            {
                path: "/map-directory/:id",
                name: "Create Map",
                props: true,
                component: () => import(/* webpackChunkName: "CreateMapDirectory" */ "./components/MapDirectory/EditMapDirectory.vue")
            }
        ]
    },
    {
        path: "/admin-users",
        name: "Admin",
        component: () => import(/* webpackChunkName: "admin" */ "./views/Admin.vue"),
        children: [
            {
                path: "",
                name: "Admin Users",
                component: () => import(/* webpackChunkName: "admin" */ "./components/Admin/AdminUsers.vue")
            },
            {
                path: "/admin-users/edit/:id",
                name: "Admin User Edit",
                component: () => import(/* webpackChunkName: "admin" */ "./components/Admin/AdminUserEdit.vue")
            },
            {
                path: "/admin-users/add/",
                name: "Add",
                component: () => import(/* webpackChunkName: "admin" */ "./components/Admin/AdminUserAdd.vue")
            }
        ]
    },
    {
        path: "/users",
        name: "Users",
        component: () => import(/* webpackChunkName: "pages" */ "./views/Admin.vue"),
        children: [
            {
                path: "",
                name: "Search",
                component: () => import(/* webpackChunkName: "PageManagement" */ "./components/Users/Cognito/Users.vue")
            },
            {
                path: "/users/edit/:id",
                name: " User Edit",
                component: () => import(/* webpackChunkName: "UserEditContainer" */ "./components/Users/Cognito/UserEdit/UserEditContainer.vue")
            },
            {
                path: "/users/add/",
                name: "Add New User",
                component: () => import(/* webpackChunkName: "PageContent" */ "./components/Users/Cognito/UserAdd.vue")
            },
            {
                path: "/users/create-entitlement/",
                name: " Create User Entitlement",
                component: () => import(/* webpackChunkName: "UserCreate" */ "./components/Users/Cognito/UserCreate/UserCreate.vue")
            }
        ]
    },
    {
        // Used if a password reset request has been performed and the user needs to set their new password using the emailed reset code
        path: "/profile",
        name: "Profile",
        component: () => import(/* webpackChunkName: "platforms" */ "./views/Profile.vue")
    },
    {
        path: "/overlay-promos",
        name: "Overlay Promos",
        component: () => import(/* webpackChunkName: "OverlayPromos" */ "./views/OverlayPromos.vue"),
        children: [
            {
                path: "",
                name: "Overlay Promos Dashboard",
                component: () => import(/* webpackChunkName: "OverlayPromosDashboard" */ "./components/OverlayPromos/OverlayPromosDashboard.vue")
            },
            {
                path: "/overlay-promos/:id",
                name: "Editor",
                component: () => import(/* webpackChunkName: "OverlayPromo" */ "./components/OverlayPromos/OverlayPromo.vue")
            }
        ]
    },
    {
        path: "/video-management",
        name: "Videos Management",
        component: () => import(/* webpackChunkName: "VideoManagement" */ "./views/VideosManager.vue"),
        children: [
            {
                path: "",
                name: "videos-management",
                component: () => import(/* webpackChunkName: "VideoManagement" */ "./vue3/components/VideosManager/VideosManagement.vue")
            },
            {
                name: "Video Content",
                path: "content",
                component: () => import(/* webpackChunkName: "VideoManagement" */ "./vue3/components/VideosManager/Sections/ContentManager.vue"),
                children: [
                    {
                        path: "content-feeds/:id",
                        name: "Edit Feed",
                        props: true,
                        component: () =>
                            import(
                                /* webpackChunkName: "VideoManagement" */ "./components/VideosManager/Data/VideoContentFeeds/VideoContentFeedEdit.vue"
                            )
                    },
                    {
                        path: "streamline-content-feeds/:id",
                        name: "Edit Content Feed",
                        props: true,
                        component: () =>
                            import(
                                /* webpackChunkName: "VideoManagement" */ "./components/VideosManager/Data/VideoContentFeedsStreamline2/ContentFeedEdit.vue"
                            )
                    },
                    {
                        path: "content-feeds/create",
                        name: "Create Feed",
                        props: true,
                        component: () =>
                            import(
                                /* webpackChunkName: "VideoManagement" */ "./components/VideosManager/Data/VideoContentFeeds/VideoContentFeedEdit.vue"
                            )
                    },
                    {
                        path: "streamline-content-feeds/create",
                        name: "Create Content Feed",
                        props: true,
                        component: () =>
                            import(
                                /* webpackChunkName: "VideoManagement" */ "./components/VideosManager/Data/VideoContentFeedsStreamline2/ContentFeedEdit.vue"
                            )
                    }
                ]
            },
            {
                name: "Video Config",
                path: "/video-management/config",
                component: () => import(/* webpackChunkName: "VideoManagement" */ "./components/VideosManager/Sections/ConfigManager.vue"),
                children: [
                    {
                        path: "categories/create",
                        name: "Create Category",
                        props: true,
                        component: () =>
                            import(/* webpackChunkName: "VideoManagement" */ "./components/VideosManager/Data/VideoCategories/EditCategories.vue")
                    },
                    {
                        path: "categories/:id",
                        name: "Edit Category",
                        props: true,
                        component: () =>
                            import(/* webpackChunkName: "VideoManagement" */ "./components/VideosManager/Data/VideoCategories/EditCategories.vue")
                    }
                ]
            },
            {
                name: "Memberships",
                path: "/video-management/memberships",
                component: () => import(/* webpackChunkName: "TeamManagement" */ "./components/VideosManager/Sections/MembershipsManager.vue"),
                children: [
                    {
                        path: "/video-management/memberships/create-membership",
                        name: "Create Membership",
                        component: () =>
                            import(/* webpackChunkName: "EditMemberships" */ "./components/VideosManager/Data/VideoMemberships/EditMembership.vue")
                    },
                    {
                        path: "/video-management/memberships/:id",
                        name: "Edit Membership",
                        component: () =>
                            import(/* webpackChunkName: "EditMemberships" */ "./components/VideosManager/Data/VideoMemberships/EditMembership.vue")
                    }
                ]
            },
            {
                name: "Schedule",
                path: "/video-management/schedule",

                children: [
                    {
                        path: "",
                        name: "Schedule",
                        component: () => import(/* webpackChunkName: "Schedule" */ "./components/VideosManager/Sections/ScheduleManager.vue")
                    },
                    {
                        path: "create-schedule/create",
                        name: "Create Schedule",
                        props: true,
                        component: () =>
                            import(/* webpackChunkName: "CreateSchedule" */ "./components/VideosManager/Data/VideoSchedule/EditSchedule.vue")
                    },
                    {
                        path: "edit-schedule/:id",
                        name: "Edit Schedule",
                        props: true,
                        component: () =>
                            import(/* webpackChunkName: "EditSchedule" */ "./components/VideosManager/Data/VideoSchedule/EditSchedule.vue")
                    }
                ]
            },
            {
                name: "Streamline",
                path: "/video-management/streamline",
                component: () => import(/* webpackChunkName: "TeamManagement" */ "./components/VideosManager/Sections/StreamlineManager.vue")
            }
        ]
    },
    {
        path: "/promos",
        name: "Promos",
        component: () => import(/* webpackChunkName: "pages" */ "./views/Promos.vue"),
        children: [
            {
                path: "",
                name: "promos-management",
                component: () => import(/* webpackChunkName: "PageManagement" */ "./components/Promos/PromoManagement.vue")
            },
            {
                path: "/promos/:id",
                name: "Promo Editor",
                component: () => import(/* webpackChunkName: "PageContent" */ "./components/Promos/PromoEditor.vue")
            }
        ]
    },
    {
        path: "/navigation",
        name: "Navigation",
        component: () => import(/* webpackChunkName: "navigation" */ "./views/Navigation.vue"),
        children: [
            {
                path: "",
                name: "navigation-all",
                component: () => import(/* webpackChunkName: "navigation" */ "./components/Navigation/NavigationAll.vue")
            },
            {
                path: "/navigation/create",
                name: "Create",
                component: () => import(/* webpackChunkName: "NavigationSingle" */ "./components/Navigation/NavigationSingle.vue")
            },
            {
                path: "/navigation/:id",
                name: "Edit",
                component: () => import(/* webpackChunkName: "NavigationSingle" */ "./components/Navigation/NavigationSingle.vue")
            }
        ]
    },
    {
        path: "/match-centre",
        name: "Match Centre",
        component: () => import(/* webpackChunkName: "match-centre" */ "./views/MatchCentre.vue")
    },
    {
        path: "/platforms",
        name: "Platforms",
        component: () => import(/* webpackChunkName: "platforms" */ "./views/Platforms.vue")
    },

    {
        path: "/pagebuilder",
        type: "external"
    },
    { path: "/:pathMatch(.*)", component: NotFound }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
